import Styles from './CloseReviewActionModal.module.scss'
import { ModalPromptProps } from 'hooks/useActionModalPrompt'
import { Transition } from './Transition'
import { ProseStateProvider } from 'common/ProseInput/ProseStateContext'
import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { ProseInput } from 'common/ProseInput/ProseInput'
import { useState } from 'react'
import { ProseState } from 'common/ProseInput/ProseState'
import { CloseReviewActionConfig, PersistedPropertyValue } from 'stores/Workflows/Types'
import { State } from 'stores/Workflows/State'
import { Modal } from 'almanac-ui/Modal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = ModalPromptProps<
  Partial<CloseReviewActionConfig>,
  {
    fromState: State
    toState: State
  }
>

export const CloseReviewActionModal = ({
  fromState,
  toState,
  onConfirm,
  onClose,
  onCancel,
  message: defaultMessage,
}: Props) => {
  const [message, setMessage] = useState(defaultMessage || '')
  const [proseState] = useState(() => new ProseState())
  const { isMobile } = useResponsiveDesign()

  const handleSubmit = () => {
    onConfirm({
      message,
    })
    onClose()
  }

  return (
    <Modal.Root onPressOutside={onCancel}>
      <Modal.Top>
        <Transition
          from={fromState.propertyValue as PersistedPropertyValue}
          to={toState.propertyValue as PersistedPropertyValue}
        />
      </Modal.Top>
      {isMobile && (
        <Modal.Header
          onClose={onClose}
          title="End Request"
          actions={
            <Transition
              from={fromState.propertyValue as PersistedPropertyValue}
              to={toState.propertyValue as PersistedPropertyValue}
            />
          }
        />
      )}
      <Modal.Content>
        <h2 className={Styles.title}>
          {toState.entryActions.length > 0
            ? 'By moving you are about to end this request and start a new automation'
            : 'By moving you are about to end this request.'}
        </h2>
        <p className={Styles.description}>All participants will be notified that the request is complete.</p>
        <div className={Styles.messageContainer}>
          <ProseStateProvider state={proseState}>
            <Toolbar.Root className={Styles.toolbar}>
              <Toolbar.Bold />
              <Toolbar.Italic />
              <Toolbar.Underline />
              <Toolbar.InlineCode />
              <Toolbar.OrderedList />
              <Toolbar.BulletList />
              <Toolbar.Mention />
              <Toolbar.Emoji />
            </Toolbar.Root>
            <ProseInput
              placeholder="Type your message participants (optional)..."
              className={Styles.message}
              initialHtmlString={message || ''}
              onChange={(html) => setMessage(html)}
            />
          </ProseStateProvider>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={onCancel} variant="tertiary" size="lg">
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleSubmit} size="lg" variant="primary">
            End Request & Move to {toState.propertyValue.value}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
